// Anything short of an outright "granted" is a no: a browser that does not know
// the "nfc" descriptor throws from query(), and guessing wrong costs a dead
// reader. Shared by the two controllers that decide whether they may arm without
// a tap — nfc-reader (falls back to its button) and nfc-guard (stays quiet).
export async function nfcPermissionGranted() {
  try {
    return (await navigator.permissions.query({ name: "nfc" })).state === "granted"
  } catch {
    return false
  }
}
